import { render, staticRenderFns } from "./wb-nav.vue?vue&type=template&id=b97600f4&scoped=true"
import script from "./wb-nav.vue?vue&type=script&lang=js"
export * from "./wb-nav.vue?vue&type=script&lang=js"
import style0 from "./wb-nav.vue?vue&type=style&index=0&id=b97600f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97600f4",
  null
  
)

export default component.exports